import {
  AssemblyDto,
  AssemblyHeaderDto,
  CuttingPlanDto,
  MaterialHeaderDto,
  RoutingHeaderDto,
  RowDto,
  WorkingStepDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'

export enum BoMItemType {
  project = 'project',
  assemblyHeader = 'assemblyHeader',
  assembly = 'assembly',
  row = 'row',
  routingHeader = 'routingHeader',
  materialHeader = 'materialHeader',
}

export enum RunnableTaskStatus {
  NotApplicable = 'NotApplicable',
  Requested = 'Requested',
  Running = 'Running',
  Done = 'Done',
  Failed = 'Failed',
}

export type RowType =
  | 'Row'
  | 'AssemblyHeader'
  | 'Assembly'
  | 'AssemblyStructure'
  | 'MaterialHeader'
  | 'RoutingHeader'

interface Row {
  id?: string
  type: RowType
  operationPending?: boolean
  validationHighlight?: boolean
  parentId?: string
  manufacturableStatus?: RunnableTaskStatus | string
  exportedToErpStatus?: RunnableTaskStatus | string
}

export interface PartTypeRow extends Row, RowDto {
  type: 'Row'
}

export interface AssemblyHeaderRow extends Row, AssemblyHeaderDto {
  type: 'AssemblyHeader'
  isOpen?: boolean
  filteredPartTypeIds?: string[]
  partTypeIds: string[]
}

export interface AssemblyRow extends Row, AssemblyDto {
  type: 'Assembly'
  isOpen?: boolean
  parentId?: string
  partTypeIds?: string[]
  subAssembliesIds?: string[]
  filteredSubAssembliesIds?: string[]
  filteredPartTypeIds?: string[]
  workingSteps?: WorkingStepDto[]
  originalFileName?: string
  isPurchasingBomItem?: boolean
}

export interface CuttingPlanRow extends CuttingPlanDto {
  operationPending?: boolean
}

export interface MaterialHeaderRow extends Row, MaterialHeaderDto {
  type: 'MaterialHeader'
  isOpen?: boolean
  filteredPartTypeIds?: string[]
  cuttingPlans?: CuttingPlanRow[]
}

export interface RoutingHeaderRow extends Row, RoutingHeaderDto {
  type: 'RoutingHeader'
  isOpen?: boolean
  filteredPartTypeIds?: string[]
}

export type BoMItemRow =
  | PartTypeRow
  | AssemblyHeaderRow
  | MaterialHeaderRow
  | AssemblyRow
  | RoutingHeaderRow
